import { Box, Button, FormControl, FormHelperText, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import DatePicker from 'react-datepicker';

import type { OU } from '@/models/Ou';

type ScheduleFormValues = {
  from: string | null;
  fromDate: Date | null;
  to: string | null;
  toDate: Date | null;
  accessLevel: string;
};

export type ScheduleFormErrors = Partial<Record<'from' | 'to' | 'accessLevel', string>>;

type Props = {
  schedule: ScheduleFormValues;
  ouData: OU;
  fieldErrors?: ScheduleFormErrors;
  isUpdate?: boolean;
  onFieldChange: (field: string, value: string | Date) => void;
  onDateChange: (field: string, value: string | Date) => void;
  onCancel: () => void;
  onSave: () => void;
};

const AccessScheduleFormControls = ({
  schedule,
  ouData,
  fieldErrors = {},
  isUpdate = false,
  onFieldChange,
  onDateChange,
  onCancel,
  onSave,
}: Props) => (
  <Box display="flex" gap={1} justifyContent="space-between" width="100%" alignItems="flex-start">
    <FormControl sx={{ flex: 1 }}>
      <DatePicker
        selected={schedule.fromDate}
        showTimeSelect
        timeIntervals={1}
        dateFormat="MM/dd/yyyy h:mm aa"
        onChange={(date) => onDateChange('from', date)}
        customInput={<TextField fullWidth label="From Date" size="small" autoComplete="false" />}
        popperPlacement="top-end"
        portalId="root"
      />
      {fieldErrors.from && <FormHelperText error>{fieldErrors.from}</FormHelperText>}
    </FormControl>

    <FormControl sx={{ flex: 1 }}>
      <DatePicker
        selected={schedule.toDate}
        showTimeSelect
        timeIntervals={1}
        dateFormat="MM/dd/yyyy h:mm aa"
        onChange={(date) => onDateChange('to', date)}
        customInput={<TextField fullWidth label="To Date" size="small" autoComplete="false" />}
        popperPlacement="top-end"
        portalId="root"
      />
      {fieldErrors.to && <FormHelperText error>{fieldErrors.to}</FormHelperText>}
    </FormControl>

    <FormControl sx={{ flex: 1 }} size="small" error={!!fieldErrors.accessLevel}>
      <InputLabel sx={{ pl: 1, pr: 1 }}>Access</InputLabel>
      <Select value={schedule.accessLevel} onChange={(e) => onFieldChange('accessLevel', e.target.value)}>
        {ouData.metaData.defaultAccessLevelOptions.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
      {fieldErrors.accessLevel && <FormHelperText>{fieldErrors.accessLevel}</FormHelperText>}
    </FormControl>

    <Button sx={{ whiteSpace: 'nowrap', height: '37px', width: '100px' }} variant="contained" onClick={onCancel}>
      Cancel
    </Button>
    <Button sx={{ whiteSpace: 'nowrap', height: '37px', width: '100px' }} variant="contained" color="primary" onClick={onSave}>
      {isUpdate ? 'Update' : 'Add'}
    </Button>
  </Box>
);

export default AccessScheduleFormControls;
